// frontend/src/utils/documentStocke.js
//
// Bucket Supabase `documents` (projet partagé avec le CRM) bientôt PRIVÉ (01/11/2026) :
// `documents.signed_document_url` enregistre une URL PUBLIQUE (`…/object/public/documents/<clé>`) qui
// ne répondra plus après la bascule. On en tire la clé et on la fait signer (5 min) au clic par la
// session de l'utilisateur (policy de lecture des connectés sur ce bucket).
import toast from 'react-hot-toast';
import { supabase } from '../lib/supabaseClient';

const MOTIF_DOCUMENTS = /\/storage\/v1\/object\/(?:public|sign|authenticated)\/documents\/([^?#]+)/;

/** La clé dans le bucket `documents` d'une URL enregistrée ; null pour tout autre lien. PUR. */
export function cleDocumentsDepuisUrl(url) {
  if (typeof url !== 'string' || !url) return null;
  const m = MOTIF_DOCUMENTS.exec(url);
  if (!m) return null;
  try {
    return decodeURIComponent(m[1]);
  } catch {
    return m[1];
  }
}

/**
 * Ouvre le document dans un nouvel onglet. Onglet ouvert de façon SYNCHRONE au clic (sinon le
 * bloqueur de fenêtres l'interdit après un `await`), puis reçoit l'URL signée. Échec : onglet
 * refermé et erreur affichée, jamais avalée. Lien hors bucket `documents` : ouvert tel quel.
 */
export async function ouvrirDocumentStocke(url) {
  if (!url) {
    toast.error('Document indisponible.');
    return 'erreur';
  }
  const onglet = window.open('', '_blank');
  if (!onglet) {
    toast.error('Votre navigateur a bloqué l’ouverture du document. Autorisez les fenêtres pour ce site.');
    return 'erreur';
  }
  onglet.opener = null;
  const cle = cleDocumentsDepuisUrl(url);
  if (!cle) {
    onglet.location.href = url;
    return 'ouvert';
  }
  const { data, error } = await supabase.storage.from('documents').createSignedUrl(cle, 300);
  if (error || !data?.signedUrl) {
    onglet.close();
    toast.error(`Document indisponible : ${error?.message || 'URL non signée'}`);
    return 'erreur';
  }
  onglet.location.href = data.signedUrl;
  return 'ouvert';
}
